import Vue from 'vue';

export default class {
    constructor(store, router) {
        this.$store = store
        this.camsTimeout = null

        router.beforeEach((to, from, next) => {
            if (to.meta.auth && ! store.state.user) {
                this.loginFromStorage().then(() => {
                    next()
                }, () => {
                    next('/auth')
                })
            } else {
                next()
            }
        })
    }
    login(data) {
        let token = btoa(unescape(encodeURIComponent(data.login + ':' + data.password)))
        let storageToken = btoa(unescape(encodeURIComponent(data.login + '㋛' + data.password)))
        let user = {
            object: data.object,
            login: data.login,
            remember: data.remember,
        }

        Vue.http.headers.common['Authorization'] = 'Basic ' + token

        return new Promise((resolve, reject) => {
            this.$store.dispatch('getCams').then(() => {
                let usersJson = localStorage.getItem('users')
                let users = usersJson ? JSON.parse(usersJson) : []
                let index = users.findIndex(item => { return item.object == user.object })

                if (index > -1)
                    users.splice(index, 1)

                users.unshift(user)

                localStorage.setItem('users', JSON.stringify(users))
                localStorage.setItem('token', storageToken)
                this.$store.commit('setUser', user)
                
                const getCams = () => {
                    this.$store.dispatch('getCams')
                    this.camsTimeout = setTimeout(getCams, PARAMS.updateInterval)
                }
                this.camsTimeout = setTimeout(getCams, PARAMS.updateInterval)
                this.$store.dispatch('setWsWebConnect').then(() => {
                    resolve()
                })
            }, (e) => {
                if (e.status === 400)
                    this.$store.commit('resetUser')

                reject(e)
            })
        })
    }

    loginFromStorage() {
        return new Promise((resolve, reject) => {
            let user = this.getUserFromStorage()

            if (user) {
                this.login(user).then(() => {
                    resolve()
                }, () => {
                    reject()
                })
            } else
                reject()
        })
    }

    getTokenFromStorage(token) {
       return decodeURIComponent(escape(atob(token))).split('㋛')
    }

    getUserFromStorage() {
        let usersJson = localStorage.getItem('users')
        let token = localStorage.getItem('token')

        if (usersJson && token) {
            let users = JSON.parse(usersJson)
            let data = this.getTokenFromStorage(token);

            if (data.length == 2) {
                let login = data[0]
                let user = users.find(item => {
                    return item.login = login
                })

                if (user) {
                    return { object: user.object, login: login, password: data[1], remember: user.remember }
                }
                else
                    return false
            } else
                return false
        } else
            return false
    }

    logout() {
        localStorage.removeItem('token')
        this.$store.commit('resetUser')
        clearTimeout(this.camsTimeout )
        this.camsTimeout = null

        return new Promise((resolve, reject) => {
            resolve()
        });
    }
}




// WEBPACK FOOTER //
// ./src/services/AuthService.js